const routes = {
  '/': 'Home',
  '/dashboard': 'Dashboard',
  '/dashboard/jobs' : 'Jobs',
  '/dashboard/users' : 'Users',
  '/dashboard/clients' : 'Clients',
  '/dashboard/capacity' : 'Capacity',
  '/dashboard/base-rates' : 'Base Rates',
  '/dashboard/accessorials' : 'Accessorials'
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js